<kui-modal #modal
    [title]="'SHARED.SELECTION.TITLE' | translate: { type: typeName }"
    [actions]="modalActions"
    (onClose)="detachModal()">
    <div class="p-2">
        <key-selection [type]="data.type"
            [id]="data.id"
            (onSelection)="selectItem($event)"></key-selection>
    </div>
</kui-modal>